import {take, takeWhile, switchMap} from 'rxjs';
import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {AnimalRepository} from "../states/animal.repository";
import {AnimalEditService} from "../services/animal-edit.service";
import {AnimalModel} from "../models/animal.model";
import {AnimalSheltersRepository} from "../../../shared/states/animal-shelter.repository";
import {AnimalOriginRepository} from "../states/animal-origin.repository";
import {AnimalWhereaboutsRepository} from "../states/animal-whereabouts.repository";
import {WaitingDialogService} from "../../../shared/services/waiting-dialog.service";
import {AnimalShelterModel} from "../../../shared/models/animal-shelter.model";
import {AnimalChangeShelterService} from "../services/animal-change-shelter.service";

@Component({
    selector: 'app-animal-move-dialog',
    templateUrl: './animal-move-dialog.component.html',
    styleUrls: ['./animal-move-dialog.component.scss'],
    standalone: false
})
export class AnimalMoveDialogComponent implements OnInit, OnDestroy {
  @Input() animal: AnimalModel | undefined;

  alive: boolean = true;
  visible: boolean = false;
  shelters: AnimalShelterModel[] | undefined;
  selectedShelter: AnimalShelterModel | undefined;
  selectedDate: string | Date | null = null;

  constructor(
    private readonly _animalEditService: AnimalEditService,
    private readonly _animalRepository: AnimalRepository,
    private readonly _animalOriginRepository: AnimalOriginRepository,
    private readonly _animalWhereaboutsRepository: AnimalWhereaboutsRepository,
    private readonly _animalShelterRepository: AnimalSheltersRepository,
    private readonly _animalChangeShelterService: AnimalChangeShelterService,
    private readonly _waitingDialogService: WaitingDialogService
  ) {
    this.selectedDate = new Date();
  }

  ngOnInit(): void {
    this._animalEditService.moveDialogVisible.pipe(takeWhile(() => this.alive)).subscribe((openModal) => {
      this.visible = openModal;
    });

    this._animalShelterRepository.getAnimalShelters().pipe(take(1)).subscribe(shelters => {
      this.shelters = shelters;
    });

    this.selectedShelter = this.animal?.animalShelter;
  }

  closeModal() {
    this._animalEditService.toggleMoveDialog();
  }

  saveChanges() {
    if (!this.animal || !this.selectedShelter || !this.selectedDate) {
      this.closeModal();
      return;
    }

    this._waitingDialogService.showWaitingDialog(true);

    this._animalChangeShelterService.changeShelter(this.animal.id, this.selectedShelter.id, this.selectedDate instanceof Date ? this.selectedDate.toISOString() : this.selectedDate)
      .pipe(
        switchMap(() => this._animalOriginRepository.getByAnimalId(this.animal!.id, false).pipe(take(1))),
        switchMap(() => this._animalWhereaboutsRepository.getByAnimalId(this.animal!.id, false).pipe(take(1))),
        switchMap(() => this._animalRepository.getById(this.animal!.id, false).pipe(take(1)))
      )
      .subscribe({
        next: (updatedAnimal) => {
          if (updatedAnimal) {
            this.animal = updatedAnimal;
          }
        },
        complete: () => {
          this._waitingDialogService.showWaitingDialog(false);
          this.closeModal();
        }
      });
  }

  get isMoveValid(): boolean {
    return !!this.selectedShelter && !!this.selectedDate && this.selectedShelter.id !== this.animal?.animalShelter?.id;
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
